import type { GasPayload } from '@atlaskit/analytics-gas-types/src';

import { EVENT_SOURCE } from '../../constants/analytics';

export const onBrowserExtensionCTAClicked = (): GasPayload => ({
	source: EVENT_SOURCE,
	eventType: 'ui',
	actionSubject: 'link',
	action: 'clicked',
	actionSubjectId: 'browserExtensionCTA',
	attributes: {
		additionalAttributes: {
			componentName: 'BrowserExtensionBanner',
		},
	},
});
